// extracted by mini-css-extract-plugin
export default {"FirstFooter":"FirstFooter__pJLn9","selected":"selected__aC22y"};